import store from '@/store';
import _ from 'lodash'
import { useSetupStore } from '@/stores';
import pinia from '@/pinia';

// this component should not be used by its own
// it needs to be extended
export default {
    name: 'Field',
    props: {
        section: {
            type: Object,
            required: false
        },
        content: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        settings: {
            type: Array
        },
        edit: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: 'medium'
        },
        maxlength: {
            type: Number,
            default: 255
        },

        // all setting values as associative object (key: value)
        sectionSettingValues: {
            type: Object,
            default: () => {
                return {};
            }
        },
        sectionSettings: {
            type: Array,
            required: false
        },
    },
    data() {
        return {
            visibleBlockSettings: false
        };
    },
    computed: {
        validationPath() {
            // TODO:
            // define validation path based on config
            return undefined;
        },
        // currentItem() {
        //     let item = null;
        //     if (this.i !== null) {
        //         const menuItems = _.get(this.form, 'menuItems', []);
        //         item = menuItems[this.i];
        //     }
        //     return item;
        // },
        // form() {
        //     return store.getters[`${this.module}/form`];
        // },
        // options() {
        //     return store.getters[`${this.module}/options`];
        // },
        inlineSettings() {
            let settings = [];

            if (this.settings && this.settings.length) {
                settings = this.settings.filter(setting => {
                    return (
                        setting.type !== 'init' &&
                        setting.position === 'inline' &&
                        setting.field === this.config.key &&
                        this.checkConditions(setting)
                    );
                });
            }

            return settings;
        },
        blockSettings() {
            let settings = [];

            if (this.settings && this.settings.length) {
                settings = this.settings.filter(setting => {
                    return (
                        setting.type !== 'init' &&
                        setting.field === this.config.key &&
                        (!setting.position || setting.position === 'block') &&
                        this.checkConditions(setting)
                    );
                });
            }

            return settings;
        },
        contentSettingValues() {
            let settingValues = {};
            let options = {};

            // select fields
            // get default values
            // so that invalid values can be determined
            if (this.settings && this.settings.length) {
                this.settings.forEach(setting => {
                    if (setting.options && setting.options.length) {
                        // const option = setting.options.find(option => option.default === true)
                        setting.options.forEach(option => {
                            if (option.default === true) settingValues[setting.key] = option.key;
                            _.set(options, `${setting.key}.${option.key}`, option.value);
                        });
                    }
                });

                // this.settings.forEach(setting => {
                //     switch (setting.type) {
                //         // case 'select:searchable-properties':
                //         // case 'multi-select:searchable-properties':
                //         //     if (setting.options && setting.options.length) {
                //         //         setting.options.forEach(option => {
                //         //             if (! settingValues[setting.key]) settingValues[setting.key] = []
                //         //             const properties = this.options.extensions.shop.property.items.filter(el => !!el.use_in_search)
                //         //             properties.forEach(property => {
                //         //                 if ((option.key == null && property.filter_component == null) || (property.filter_component === option.key)) {
                //         //                     settingValues[setting.key].push({ key: property.key, value: property.name })
                //         //                     _.set(options, `${setting.key}.${property.key}`, property.name)
                //         //                 }
                //         //             })
                //         //         })
                //         //     } else {
                //         //         if (! settingValues[setting.key]) settingValues[setting.key] = []
                //         //         const properties = this.options.extensions.shop.property.items.filter(el => !!el.use_in_search)
                //         //         properties.forEach(property => {
                //         //             settingValues[setting.key].push({ key: property.key, value: property.name })
                //         //             _.set(options, `${setting.key}.${property.key}`, property.name)
                //         //         })
                //         //     }
                //         //     break;
                //         // case 'select:sortable-properties':
                //         // case 'multi-select:sortable-properties':
                //         //     if (! settingValues[setting.key]) settingValues[setting.key] = []
                //         //     const properties = this.options.extensions.shop.property.items.filter(el => !!el.is_sortable)
                //         //     properties.forEach(property => {
                //         //         settingValues[setting.key].push({ key: property.key, value: property.name })
                //         //         _.set(options, `${setting.key}.${property.key}`, property.name)
                //         //     })
                //         //     break;
                //         // case 'select:subscription-topics':
                //         // case 'multi-select:subscription-topics':
                //         //     if (! settingValues[setting.key]) settingValues[setting.key] = []
                //         //     const subscriptionTopics = this.options.extensions.newsletter.subscriptionTopic.items
                //         //     subscriptionTopics.forEach(topic => {
                //         //         settingValues[setting.key].push({ key: topic.key, value: topic.name })
                //         //         _.set(options, `${setting.key}.${topic.key}`, topic.name)
                //         //     })
                //         //     break;
                //         // case 'select:member-tags':
                //         // case 'multi-select:member-tags':
                //         //     if (! settingValues[setting.key]) settingValues[setting.key] = []
                //         //     const memberTags = this.options.extensions.restrictedArea.memberTag.items
                //         //     memberTags.forEach(memberTag => {
                //         //         // settingValues[setting.key].push({ key: memberTag.key, value: memberTag.name })
                //         //         _.set(options, `${setting.key}.${memberTag.key}`, memberTag.name)
                //         //     })
                //         //     break;
                //         case 'checkbox':
                //         case 'switch':
                //             settingValues[setting.key] = false
                //             if (setting.value) {
                //                 settingValues[setting.key] = ['true', '1', 'yes', true].includes(setting.value)
                //             }
                //             break;
                //
                //         default:
                //             if (setting.options && setting.options.length) {
                //                 setting.options.forEach(option => {
                //                     if (option.default === true && ! settings.find(el => el.key === setting.key)) {
                //                         if (['multi-select', 'tags'].includes(setting.type)) {
                //                             if (! settingValues[setting.key]) settingValues[setting.key] = []
                //                             settingValues[setting.key].push({ key: option.key, value: option.value })
                //                         } else {
                //                             settingValues[setting.key] = option.key
                //                         }
                //                     }
                //                     _.set(options, `${setting.key}.${option.key}`, option.value)
                //                 })
                //             } else {
                //                 settingValues[setting.key] = setting.value
                //             }
                //             break
                //     }
                // })
            }

            // override with actual values
            if (this.content.settings && this.content.settings.length) {
                this.content.settings.forEach(setting => {
                    // check if selected option exists

                    // get related configuration (defined in temaplte JSON)
                    const config = this.settings.find(el => el.key === setting.key);
                    const type = _.get(config, 'type');

                    switch (type) {
                        case 'tags':
                        case 'select':
                        case 'multi-select':
                        // case 'select:member-tags':
                        // case 'multi-select:member-tags':
                        case 'select:subscription-topics':
                        case 'multi-select:subscription-topics':
                            if (setting.key && setting.value != null && _.get(options, `${setting.key}.${setting.value}`) !== undefined) {
                                settingValues[setting.key] = setting.value;
                            } else if (setting.options && setting.options.length) {
                                settingValues[setting.key] = setting.options;
                            }
                            break;

                        // case 'select:searchable-properties':
                        // case 'multi-select:searchable-properties':
                        // case 'select:sortable-properties':
                        // case 'multi-select:sortable-properties':
                        //     if (setting.key && setting.options) {
                        //         let values = []
                        //         setting.options.forEach(option => {
                        //             if (option.key && option.value != null && _.get(options, `${setting.key}.${option.key}`) !== undefined) {
                        //                 values.push(option)
                        //             }
                        //         })
                        //         settingValues[setting.key] = values
                        //     }
                        //
                        //     // if (setting.options && setting.options.length) {
                        //     //     settingValues[setting.key] = setting.options
                        //     // } else if (setting.options === null) {
                        //     //     settingValues[setting.key] = []
                        //     // }
                        //     break;

                        case 'checkbox':
                        case 'switch':
                            settingValues[setting.key] = false;
                            if (setting.value) {
                                settingValues[setting.key] = ['true', '1', 'yes', true].includes(setting.value);
                            }
                            break;

                        default:
                            settingValues[setting.key] = setting.value;
                    }
                });
            }

            return settingValues;
        },
        enabledExtensions() {
            return useSetupStore(pinia).enabledExtensions;
        },
    },
    methods: {
        checkConditions(setting) {
            let valid = true;

            // eslint-disable-next-line no-unused-vars
            const settings = this.contentSettingValues;
            const sectionSettings = this.sectionSettingValues;
            const enabledExtensions = this.enabledExtensions;
            try {
                const conditions = setting.conditions;
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return;

                        const { type, condition } = o;
                        switch (type) {
                            case 'eval':
                                valid = eval(condition);
                                break;

                            default:
                                valid = false;
                        }
                    });
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false;
            }

            return valid;
        },
        updateSetting(payload) {
            this.$emit('update-settings', payload);

            // if (this.c !== undefined) {
            //     let mutation = 'contentSettingsValue';
            //     if (payload.value && _.isArray(payload.value)) {
            //         mutation = 'contentSettingsOptions';
            //         payload.options = payload.value;
            //         delete payload.value;
            //     }
            //     store.commit(`${this.module}/form/${mutation}`, { i: this.i, s: this.s, c: this.c, ...payload });
            // }


            const { key, field, value } = payload;

            let k = 'value';
            if (value != null && _.isArray(value)) k = 'options'


            let settings = _.get(this.content, 'settings');
            if (!settings) {
                this.$set(this.content, 'settings', []);
                this.$set(this.content.settings, 0, { key, [k]: value });
                // settings = [{ key, [k]: value }];
            } else if (settings && settings.length === 0) {
                this.$set(this.content.settings, 0, { key, [k]: value });
                // settings.push({ key, [k]: value })
            } else {
                const index = _.findIndex(settings, { key });
                if (index >= 0) {
                    this.$set(this.content.settings, index, { key, [k]: value });
                    // settings[index] = { key, [k]: value }
                } else {
                    this.$set(this.content.settings, settings.length, { key, [k]: value });
                    // settings.push({ key, [k]: value })
                }
            }

            // this.$set(this.content, 'settings', settings);
        }
    }
};
